import _object_spread from "@swc/helpers/src/_object_spread.mjs";
import _object_spread_props from "@swc/helpers/src/_object_spread_props.mjs";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import Svg from "../Svg";
var Icon = function(props) {
    return /*#__PURE__*/ _jsxs(Svg, _object_spread_props(_object_spread({
        xmlns: "http://www.w3.org/2000/svg",
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none"
    }, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M17.5893 8.07741C17.9147 8.40285 17.9147 8.93049 17.5893 9.25592L10.9226 15.9226C10.5972 16.248 10.0695 16.248 9.74408 15.9226L6.41074 12.5893C6.08531 12.2638 6.08531 11.7362 6.41074 11.4107C6.73618 11.0853 7.26382 11.0853 7.58926 11.4107L10.3333 14.1548L16.4107 8.07741C16.7362 7.75197 17.2638 7.75197 17.5893 8.07741Z",
                fill: props.color || "#000"
            }),
            /*#__PURE__*/ _jsx("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M12 3.66667C7.39763 3.66667 3.66667 7.39763 3.66667 12C3.66667 16.6024 7.39763 20.3333 12 20.3333C16.6024 20.3333 20.3333 16.6024 20.3333 12C20.3333 7.39763 16.6024 3.66667 12 3.66667ZM2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12Z",
                fill: props.color || "#000"
            })
        ]
    }));
};
export default Icon;
